import siteVars from "../utils/utils";

export function moneyFormat(value) {
    const locale = siteVars.locale.replace('_', '-');
    const currency = siteVars.currency_readable;
    const formattedValue = value.toLocaleString(locale, {minimumFractionDigits: 0});
    return `${formattedValue}${currency}`;
}